import { render } from "./MoveKit.vue?vue&type=template&id=25c2dfe4&scoped=true"
import script from "./MoveKit.vue?vue&type=script&lang=js"
export * from "./MoveKit.vue?vue&type=script&lang=js"

import "./MoveKit.vue?vue&type=style&index=0&id=25c2dfe4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25c2dfe4"]])

export default __exports__